export const data = {
  error: "Something Wrong in Data",
  reception: "reception",
  orders: "orders",
  login: "LOGIN",
  status: "Status",
  prepared: "Prepared",
  deliver: "Delivered",
  qty: "Qty",
  item: "Item",
  forgot_password: "FORGOT PASSWORD?",
  userName_error: "PLease Enter User Name",
  userPassword_error: "Please Enter User Password",
  acknowledge: "Acknowledge",
  dispatch: "Dispatch",
  no_request: "No Requests Yet!",
  check_in: "Check In",
  check_out: "Checkout",
  check_in_msg: "Click on the button to check-in",
  login_error: "The Email and Password you entered is incorrect.",
};
